"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useDropdownOptions = void 0;
var React = __importStar(require("react"));
var useOpenClose_1 = require("./useOpenClose");
var useDropdownOptions = function (_a) {
    var onSelection = _a.onSelection, options = _a.options, initialOption = _a.initialOption;
    var emptyOption = '';
    var _b = React.useState(emptyOption), selected = _b[0], setSelected = _b[1];
    var _c = (0, useOpenClose_1.useOpenClose)({
        initialState: false,
    }), isOpen = _c.isOpen, toggle = _c.toggle, close = _c.close;
    var handleSelection = React.useCallback(function (option) {
        onSelection(option);
        setSelected(option);
    }, [onSelection]);
    // ensure we call the onSelection callback when the initial option is selected
    React.useEffect(function () {
        if (initialOption && selected === emptyOption && options.length > 0) {
            handleSelection(initialOption);
        }
    }, [handleSelection, initialOption, options.length, selected]);
    // Reset the selected option when options are empty
    React.useEffect(function () {
        if (options.length > 0)
            return;
        setSelected(emptyOption);
    }, [options.length, setSelected]);
    return { handleSelection: handleSelection, selected: selected, isOpen: isOpen, toggle: toggle, close: close };
};
exports.useDropdownOptions = useDropdownOptions;
//# sourceMappingURL=useDropdownOptions.js.map